import React, { lazy, Suspense, useEffect } from 'react';
import TableSkeleton from '../../../components/TableSkeleton';
import Spinner from '../../../components/Spinner';
// import { Skeleton } from '../../../components/ui/skeleton';
import FiltersSkeleton from '../../../components/FiltersSkeleton';
import { useExtVersions } from '../../../contexts/extractions/ExtVersionContext';
import ErrorMessageModal from './ErrorMessageModal';

const Filters = lazy(() => import('./Filters'));
const TanstackTable = lazy(() => import('../../../components/TanstackTable'));
// const TanstackColumns = lazy(() => import('../../../components/TanstackColumns'));
// const Update = lazy(() => import('./Update'));
const ConfirmDialog = lazy(() => import('../../../components/ConfirmDialog'));

const Manage = () => {
    const {
        table,
        columns,
        loading,
        extVersions,
        updateData,
        setOpenUpdateModal,
        showDeleteConfirmationDialog,
        handleCloseModal,
        handleDelete,
        showErrorModal,
        handleCloseErrorModal,
        errorModalData,
    } = useExtVersions();

    useEffect(() => {
        if (updateData.id !== "") { 
            setOpenUpdateModal(true);
        }
    }, [updateData, setOpenUpdateModal]);
    
    return (
        <>
            <div>
                <div className="flex justify-between mb-4 hidden md:flex">
                    <Suspense fallback={<FiltersSkeleton/>}>
                        <Filters />
                    </Suspense>
                    <div className="flex items-start mb-4">
                        {/* <Suspense fallback={<Skeleton className="w-5 h-5"/>}>
                            <TanstackColumns table={table} data={extVersions} columns={columns} rightButton={<Add />} />
                        </Suspense> */}
                    </div>
                </div>
                <div className="flex flex-col gap-4 justify-between mb-4 md:hidden">
                    {/* <Suspense fallback={<FiltersSkeleton/>}>
                        <Filters />
                    </Suspense> */}
                </div>
            </div>
            <Suspense fallback={<TableSkeleton columns={5} rows={5} headers={["#", "Code", "Title", "Status", "Actions"]}/>}> 
                <TanstackTable
                    loading={loading}
                    table={table}
                    data={extVersions || []}
                    columns={columns}
                    // pagination={pagination}
                    // handlePageChange={handlePageChange}
                />
            </Suspense>
            {/* <Suspense fallback={<Spinner/>}>
                <Update
                    data={updateData}
                    open={openUpdateModal}
                    handleClose={e => handleCloseModal('update')}
                />
            </Suspense> */}
            <Suspense fallback={<Spinner/>}>
                <ConfirmDialog
                    open={showDeleteConfirmationDialog}
                    confirmAction={handleDelete}
                    handleClose={e => handleCloseModal('delete')}
                    actionText="Delete"
                    descriptionText="Are you sure you want to delete this Version?"
                />
            </Suspense>
            <ErrorMessageModal 
                open={showErrorModal}
                handleClose={handleCloseErrorModal}
                data={errorModalData}
            />
        </>
    );
};

export default Manage;
